<template>
  <v-snackbar
    v-model="snackbar.show"
    :color="snackbar.color || undefined"
    :timeout="snackbar.timeout != null ? snackbar.timeout : 5000"
    :bottom="!snackbar.important"
    :top="snackbar.important"
    :key="snackbar.important"
    class="mb-4"
    :class="{ clickable: snackbar.href }"
    @click="
      goTo();
      snackbar.show = false;
    "
  >
    <v-icon v-if="snackbar.icon" left small>{{ snackbar.icon }}</v-icon>
    {{ snackbar.message }}
    <template v-slot:action="{ attrs }" v-if="snackbar.closable">
      <v-btn icon v-bind="attrs" @click.stop="snackbar.show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      snackbar: this.$store.getters.getSnackbarInstance,
    };
  },
  methods: {
    goTo() {
      if (this.snackbar.href) {
        this.$router.push(this.snackbar.href);
      }
    },
  },
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
</style>
